const _ = require('lodash');

export default function validate(getValidationSchema) {
  return values => {
    const validationSchema = getValidationSchema(values);
    try {
      validationSchema.validateSync(values, { abortEarly: false });
      return {};
    } catch (error) {
      return getErrorsFromValidationError(error);
    }
  };
}

function getErrorsFromValidationError(validationError) {
  const FIRST_ERROR = 0;
  return validationError.inner.reduce((errors, error) => {
    let path = '';
    path = error.path;
    return {
      ...errors,
      [path]: error.errors[FIRST_ERROR]
    };
  }, {});
}
